var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-steps',{attrs:{"space":300,"active":_vm.active,"align-center":"","finish-status":"success"}},[_c('el-step',{attrs:{"title":_vm.$t('Pendaftaran')}}),_c('el-step',{attrs:{"title":_vm.$t('Pendaftaran digisign')}}),_c('el-step',{attrs:{"title":_vm.$t('Pendaftaran RDL')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }